<template>
  <b-card class="mt-3">
    <div class="row d-flex align-items-center justify-content-center">
      <div>
        <h5 class="text-center">{{ label }}</h5>
        <div style="border: 1px solid #2980b9">
          <div
            v-if="!signatureToShow"
            style="width: 400px; height: 150px; font-size: 40px;"
            class="d-flex align-items-center justify-content-center"
          >
            Sin firma
          </div>

          <img
            v-if="signatureToShow"
            :src="signatureToShow" 
            alt="Firma paciente" 
          />
        </div>
      </div>

      <b-button
        variant="warning"
        class="mb-0 ml-2"
        title="Cambiar firma"
        @click="onOpenModalSignature"
      >
        <i class="fa-solid fa-rotate" />
      </b-button>
    </div>

    <TopazSignature 
      v-model="base64Signature"
      :isVisible.sync="openModalSignature"
    />

  </b-card>
</template>

<script>
import TopazSignature from "@/views/topaz/TopazSignature.vue";
import { saveRespaldo } from '../../atencionCita/helpers';

export default {
  name: 'ProcessSignature',
  
  props: {
    base64Signature: {
      type: String,
    },

    isAtencion: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ''
    }
  },

  components: {
    TopazSignature
  },


  created() {
    this.loadData();
  },

  data() {
    return {
      openModalSignature: false,
      signatureToShow: null,

      signatureInicial: null,
      flagLoadInicial: false
    }
  },


  methods: {

    loadData(){

      this.loadFirmaInicial();

      if(!this.isAtencion) return;

      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;

      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;
    },


    loadFirmaInicial() {
      this.formatImagenToShow(this.base64Signature);

      if(!this.flagLoadInicial) {
        this.flagLoadInicial = true
        this.signatureInicial = this.base64Signature;
      }
    },


    onOpenModalSignature() {
      this.openModalSignature = true
    },

    formatImagenToShow(base64) {

      if(!base64) {
        this.signatureToShow = null
        return;
      }

      this.signatureToShow = (!base64.startsWith('data:image/png;base64,')) 
        ? `data:image/png;base64,${base64}`
        : base64

    }
  },

  watch: {

    base64Signature(newValue) {

      let newSignature = newValue;
      if(!newSignature) newSignature = this.signatureInicial

      this.formatImagenToShow(newSignature);
      this.$emit('signatureBlob', newSignature);

      if(!this.isAtencion) return;
      saveRespaldo(this.identificadorAtencion, 'signature', newValue);
    }
  }
}
</script>
